<template>
  <div id="main">
    <div>
      <img alt="" ref="assessImg" src="@/assets/img/maintain/maintain.png" style="width: 100%; position:absolute;text-align: center;">

      <div class="content" :style="{top:fullHeight * ( 0.20 ) + 'px'}">
        <div v-html = "maintainInfo.content">{{maintainInfo.content}}</div>
        <el-button @click="tabRemove" type="primary">关闭</el-button>
      </div>

    </div>
  </div>
</template>

<script>
  /**
   * @author zhengf
   */
  export default {
    name: "maintainInfo",
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
      //这里存放数据
      return {
        content: '1111',
        fullHeight: document.documentElement.clientHeight, // 页面高度
        fullWidth: document.documentElement.clientWidth, // 页面宽度  - 250  (左边导航宽度)

        maintainInfo:{
          content:''
        },
        mentSwitchUrl : this.$route.query.menu
      }
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
      $route(){
        this.mentSwitchUrl= this.$route.query.menu
        this.init()
      },
    },
    //方法集合
    methods: {
      // 数据初始化
      init() {

        this.$request
          .post('/sys/sysmenuswitch/getOne', {menuUrl:this.mentSwitchUrl})
          .then((res, total, code, data) => {
            console.log('init')
            console.log(data)
            if (data.code === 1) {
              this.content = data.data.content
              this.maintainInfo.content = data.data.content
              this.$set(this.maintainInfo,'content',data.data.content)
              console.log('this.content')
              console.log(this.content)
            }else {
              this.$message.warning(data.msg)
            }
          })
          .catch((err) => {
            console.log(err)
          })
      },

      // 删除当前页面
      tabRemove () {
        let tabName = this.$store.state.contentTabsActiveName
        if (tabName === 'home') {
          return false
        }
        this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
        if (this.$store.state.contentTabs.length <= 0) {
          this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
          return false
        }
        // 当前选中tab被删除
        if (tabName === this.$store.state.contentTabsActiveName) {
          this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
        }
      },
    },

    //创建前：
    beforeCreate() {
      console.log('beforeCreate')
    },
    // 创建完成 实例已经创建完成之后被调用
    created() {
      this.$eventHub.$on(this.GLOBAL.TODO_TASK, data => {
        console.log('maintailInfo --- ')
        console.log(window.SITE_CONFIG['mentSwitchUrl'])
      })
    },
    //挂载前：在挂载开始之前被调用：相关的 render 函数首次被调用
    beforeMount() {
      console.log('beforeMount')
    },
    // 挂载完成：
    mounted() {
      console.log('mounted')
    },
    activated() {
      this.init()
    },
    // 即将更新渲染: 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
    beforeUpdate() {
      console.log('beforeUpdate')
    },
    // 更新成功
    updated() {
      console.log('updated')
    },
    // 实例销毁之前调用
    beforeDestroy() {
      console.log('beforeDestroy')
    },
    //Vue 实例销毁后调用
    destroyed() {
      console.log('destroyed')
    }

  }
</script>

<style scoped>
  .content{
    position:absolute;
    width: 100%;
    text-align:center;
  }
</style>
